import React, { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { cloneDeep } from 'lodash';
import { IEditorSpeaker, SpeakerModalStage } from '../../../redux/store/IStore';
import { SelectionState } from 'draft-js';
import { setEditorStateChanged, updateSpeakerModal } from '../../../redux/features/app/app';
import Checkbox from '@mui/material/Checkbox';
import SpeakerSection from '../SpeakerSection';

interface IChangeRole {
  value: string;
  selected: boolean;
}

interface ISpeakerModalProps {
  replaceSpeaker: (
    newSpeaker: IEditorSpeaker,
    oldSpeaker: IEditorSpeaker | undefined,
    replaceAll: boolean,
    blockKey: string
  ) => void;
  setSpeakerToSelection: (sel: SelectionState, speaker?: IEditorSpeaker) => void;
}
const SpeakerModalReplace = ({ replaceSpeaker, setSpeakerToSelection }: ISpeakerModalProps) => {
  const dispatch = useAppDispatch();

  const { blockKey, selectedSpeaker, editorSelection, oldSpeaker } = useAppSelector(
    (state) => state.app.speakerModal
  );

  const [roles, setRoles] = useState<IChangeRole[]>(
    selectedSpeaker
      ? selectedSpeaker.roles.map((role, index) => {
          return {
            value: role,
            selected: index === 0,
          };
        })
      : []
  );

  const [replaceAll, setReplaceAll] = useState<boolean>(false);

  const changeRole = (roleIndex: number) => {
    const copy = cloneDeep(roles);
    copy.forEach((role, index) => (role.selected = index === roleIndex ? !role.selected : false));
    setRoles(copy);
  };

  const goBack = () => dispatch(updateSpeakerModal({ modalStage: SpeakerModalStage.list }));

  const swap = () => {
    const selectedRoles = roles.filter((role) => role.selected);
    const selectedRole = selectedRoles.length > 0 ? selectedRoles[0].value : undefined;
    if (!editorSelection && selectedSpeaker && blockKey) {
      replaceSpeaker(
        { ...selectedSpeaker, selectedRole, vectorSynced: false },
        oldSpeaker,
        replaceAll,
        blockKey
      );
      dispatch(
        updateSpeakerModal({
          blockKey: null,
          editorSelection: null,
          selectedSpeaker: undefined,
          modalStage: undefined,
          opened: false,
          oldSpeaker: undefined,
        })
      );
      dispatch(setEditorStateChanged(true));
      return;
    }

    if (editorSelection && selectedSpeaker) {
      setSpeakerToSelection(editorSelection, { ...selectedSpeaker, selectedRole, vectorSynced: false });
      dispatch(
        updateSpeakerModal({
          blockKey: null,
          editorSelection: null,
          selectedSpeaker: undefined,
          modalStage: undefined,
          opened: false,
          oldSpeaker: undefined,
        })
      );
      dispatch(setEditorStateChanged(true));
      return;
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
      <div>
        <p id="speaker_modal_header_title">Zamenjaj govorca z </p>
        {selectedSpeaker && <SpeakerSection speaker={selectedSpeaker} isFirst={false} />}
        {/*<p>Novi govorec {selectedSpeaker && selectedSpeaker.name}</p>*/}

        <div style={{ marginTop: 32 }}>
          <p>Izberi vlogo</p>
          <div id="speaker_roles_container">
            {roles.map((iterationRole, index) => {
              return (
                <button
                  onClick={() => changeRole(index)}
                  className={`speaker_role${iterationRole.selected ? ' speaker_role_default' : ''}`}
                >
                  <p>{iterationRole.value}</p>
                </button>
              );
            })}
          </div>
        </div>

        <div id="switch_all_container">
          <div>Zamenjaj vse</div>
          <Checkbox
            checked={replaceAll}
            onChange={() => {
              setReplaceAll(!replaceAll);
            }}
            value="replaceAll"
            color="primary"
          />
        </div>
      </div>

      <div id="speaker_modal_footer">
        <button id="spekaer_modal_close_button" onClick={goBack}>
          NAZAJ
        </button>
        <button id="spekaer_modal_save_button" onClick={swap}>
          ZAMENJAJ
        </button>
      </div>
    </div>
  );
};

export default SpeakerModalReplace;
